var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createAction, createReducer } from '@reduxjs/toolkit';
import * as statuses from 'services/store/states';
import * as types from './types';
var initialState = {
    status: statuses.IDLE,
    subscriptions: [],
    monthlyCost: 0,
    yearlyCost: 0,
    payment: {
        status: statuses.IDLE,
        data: null,
    },
    invoices: [],
    products: {
        status: statuses.IDLE,
        list: [],
    },
    calendar: {
        status: statuses.IDLE,
        url: '',
    },
};
/* const getNextPayment = (payload: any) => {
  const payments = payload.sort((a: any, b: any) =>
  Number.parseInt(`${a?.date.day}${a?.date.month}`, 10) -
  Number.parseInt(`${b?.date.day}${b?.date.month}`, 10));
  return (payload.length > 1 && payments[0])
    ? payments[0]?.date
    : ((payload[0] && payload[0]?.date) || '');
}; */
var fetchSubscriptions = createAction(types.FETCH_SUBSCRIPTION_LOADING);
var fetchSubscriptionsSuccess = createAction(types.FETCH_SUBSCRIPTION_SUCCESS);
var fetchSubscriptionsError = createAction(types.FETCH_SUBSCRIPTION_ERROR);
var fetchProducts = createAction(types.FETCH_PRODUCTS_LOADING);
var fetchProductsSuccess = createAction(types.FETCH_PRODUCTS_SUCCESS);
var fetchProductsError = createAction(types.FETCH_PRODUCTS_ERROR);
var fetchLegalCalendar = createAction(types.FETCH_LEGAL_CALENDAR_LOADING);
var fetchLegalCalendarSuccess = createAction(types.FETCH_LEGAL_CALENDAR_SUCCESS);
var fetchLegalCalendarError = createAction(types.FETCH_LEGAL_CALENDAR_ERROR);
var fetchPaymentDefaultMethod = createAction(types.FETCH_PAYMENT_DEFAULT_METHOD_LOADING);
var fetchPaymentDefaultMethodSuccess = createAction(types.FETCH_PAYMENT_DEFAULT_METHOD_SUCCESS);
var fetchPaymentDefaultMethodError = createAction(types.FETCH_PAYMENT_DEFAULT_METHOD_FAIL);
var updateSubscriptionSuccess = createAction(types.UPDATE_SUBSCRIPTION_SUCCESS);
var cancelSubscriptionSuccess = createAction(types.CANCEL_SUBSCRIPTION_SUCCESS);
var subscriptionsReducer = createReducer(initialState, function (builder) {
    builder
        .addCase(fetchSubscriptions, function (state) { return (__assign(__assign({}, state), { status: statuses.LOADING })); })
        .addCase(fetchSubscriptionsSuccess, function (state, _a) {
        var payload = _a.payload;
        return (__assign(__assign({}, state), { status: statuses.SUCCESS, subscriptions: payload }));
    })
        .addCase(fetchSubscriptionsError, function (state) { return (__assign(__assign({}, state), { status: statuses.FAIL })); })
        .addCase(fetchProducts, function (state) { return (__assign(__assign({}, state), { products: __assign(__assign({}, state.products), { status: statuses.LOADING }) })); })
        .addCase(fetchProductsSuccess, function (state, _a) {
        var payload = _a.payload;
        return (__assign(__assign({}, state), { products: __assign(__assign({}, state.products), { status: statuses.SUCCESS, list: payload }) }));
    })
        .addCase(fetchProductsError, function (state) { return (__assign(__assign({}, state), { products: __assign(__assign({}, state.products), { status: statuses.FAIL }) })); })
        .addCase(fetchLegalCalendar, function (state) { return (__assign(__assign({}, state), { calendar: __assign(__assign({}, state.calendar), { status: statuses.LOADING }) })); })
        .addCase(fetchLegalCalendarSuccess, function (state, _a) {
        var payload = _a.payload;
        return (__assign(__assign({}, state), { calendar: __assign(__assign({}, state.calendar), { status: statuses.SUCCESS, url: payload }) }));
    })
        .addCase(fetchLegalCalendarError, function (state) { return (__assign(__assign({}, state), { calendar: __assign(__assign({}, state.calendar), { status: statuses.FAIL }) })); })
        .addCase(fetchPaymentDefaultMethod, function (state) { return (__assign(__assign({}, state), { payment: __assign(__assign({}, state.payment), { status: statuses.LOADING }) })); })
        .addCase(fetchPaymentDefaultMethodSuccess, function (state, _a) {
        var payload = _a.payload;
        return (__assign(__assign({}, state), { payment: __assign(__assign({}, state.payment), { status: statuses.SUCCESS, data: payload }) }));
    })
        .addCase(fetchPaymentDefaultMethodError, function (state) { return (__assign(__assign({}, state), { payment: __assign(__assign({}, state.payment), { status: statuses.FAIL }) })); })
        .addCase(updateSubscriptionSuccess, function (state, _a) {
        var payload = _a.payload;
        return (__assign(__assign({}, state), { subscriptions: state.subscriptions
                .map(function (sub) { return (sub.idStripe === payload.idStripe ? payload : sub); }) }));
    })
        .addCase(cancelSubscriptionSuccess, function (state, _a) {
        var payload = _a.payload;
        return (__assign(__assign({}, state), { subscriptions: state.subscriptions.filter(function (sub) { return sub.idStripe !== payload; }) }));
    });
});
export default subscriptionsReducer;
